import { defineStore } from 'pinia';
import state from './state.js';

export const useFlowStore = defineStore('flow', {
    state() {
        return state;
    },
});
